module.exports = __webpack_public_path__ + "static/img/Emma-150x150.b94b669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Emma-150x150.jpg
// module id = j+t0
// module chunks = 1